<template>
    <div class="mainBox">
        <div class="main-header">
            <el-row :gutter="10">
                <el-col :span="6">
                    <el-button type="primary" icon='el-icon-plus' size="medium" @click='handleInsert'>新增广告</el-button>
                    <el-button icon='el-icon-refresh' size="medium" @click='init'>刷新</el-button>
                </el-col>
                <el-col :span="18">
                    <el-form ref="search_form" :model="searchForm" class='search_form'>
                        <el-row :gutter="10">
                            <el-col :span="3" :offset="18">
                                <el-form-item prop="language">
                                    <el-select v-model="searchForm.language" @change='searchFormDatas' placeholder="请选择语言" clearable>
                                        <el-option label="中文" value="cn"></el-option>
                                        <el-option label="英文" value="en"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="primary" class="searchBtn" size="medium" icon='el-icon-search' @click='searchFormDatas'>查询</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>
        </div>
        <div class="main-content">
            <el-table :data="mainLists" border>
                <el-table-column
                    label="广告ID"
                    prop="id"
                    width="80px"
                    align="center">
                </el-table-column>
                <el-table-column label="语言" width="100" align="center" prop="language">
                    <template slot-scope="scope">
                        <span v-if="scope.row.language == 'cn'">中文</span>
                        <span v-if="scope.row.language == 'en'">英文</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="类型"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="title"
                    label="标题"
                    align="center">
                </el-table-column>
                <el-table-column label="图片" width="180" align="center" prop="img">
                    <template slot-scope="scope">
                        <el-image style="width:60px; height:40px; vertical-align: top;" :src="scope.row.img+'!v200'" fit="cover"></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="url"
                    label="链接"
                    min-width="100px">
                </el-table-column>
                <el-table-column label="排序" width="100" align="center" prop="weigh">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <p>{{scope.row.status == 'active' ? '开启' : '关闭'}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="created_at"
                    label="创建时间"
                    align="center"
                     width="200">
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="220"
                    align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row)">
                            编辑
                        </el-button>
                        <el-button
                            type="danger"
                            size="mini"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row,scope.$index)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination-footer" v-show="pagination.totalNum > 0">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pagination.page"
                :page-size="pagination.pageSize"
                :total="pagination.totalNum"
                @current-change="pageChangeHandle">
            </el-pagination>
        </div>
        <el-dialog title="广告管理" :visible.sync="showUserDialogVisible" @close="handleReset" :close-on-click-modal="false">
            <ad-edit ref="adEdit" :adForm="adForm"></ad-edit>
            <template slot="footer">
                <el-button size="medium" @click="handleReset">取消</el-button>
                <el-button size="medium" type="primary" @click="handleSave">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {adList,adCreate,adUpdate,adDel} from '@/utils/getData';
    const adEdit = ()=>import('@/components/content/adEdit');

    export default {
        name: "adlist",
        components:{
            adEdit
        },
        data(){
            return{
                searchForm:{
                    type:"banner",
                    language:'',
                },
                mainLists:[],//列表
                pagination: {
                    page: 1, //当前页数
                    pageSize: 20, //每页显示的条数
                    totalNum: 100 //总条数
                },
                showUserDialogVisible:false,
                adForm:{},
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            async init(){
                adList(this.pagination.page, this.searchForm).then(res => {
                    if (res.code == 0) {
                        this.pagination.pageSize = res.data.pageSize;
                        this.pagination.totalNum = res.data.count;
                        this.mainLists = res.data.rows;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                })
            },
            searchFormDatas() { //表单搜索
                this.init();
            },
            pageChangeHandle(val){
                this.pagination.page = val;
                this.init();
            },
            handleInsert(){//新增
                this.adForm = {status:"active",type:"banner",weigh:1};
                this.showUserDialogVisible = true;
            },
            handleEdit(currentRow){//编辑
                this.adForm = JSON.parse(JSON.stringify(currentRow));
                this.showUserDialogVisible = true;
            },
            handleSave(){//保存
                const adForm = this.$refs["adEdit"].$refs["adForm"];
                adForm.validate(async valid=>{
                    if(valid){
                        let res = {},formData = adForm.model;
                        if(formData.id){//编辑
                            res = await adUpdate(formData.id,formData);
                        }else{//新增
                            res = await adCreate(formData);
                        }
                        if (res.code == 0) {
                            if(formData.id){//编辑
                                const index = this.mainLists.findIndex(item=>{
                                    return item.id == formData.id;
                                });
                                if(index != -1){
                                    this.$set(this.mainLists,index,res.data);
                                }
                            }else{//新增
                                this.mainLists.unshift(res.data);
                            }
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'success'
                            });
                            this.showUserDialogVisible = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            handleDelete(currentRow,index){//删除
                this.$confirm('确定要删除吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const res = await adDel(currentRow.id);
                    if (res.code == 0) {
                        this.mainLists.splice(index,1);
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                }).catch((e) => {
                    if(e == 'cancel'){
                        return false;
                    }
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                });
            },
            handleReset(){//重置表单
                this.$refs["adEdit"].$refs["adForm"].resetFields();
                this.showUserDialogVisible = false;
            }
        }
    }
</script>

<style scoped>
</style>